export default __webpack_public_path__ + "static/media/21.0d2803df.jpg";